const SliderMarks = {
  marksTenure: [
    { value: 0, label: "0" },
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ],
  marksInt: [
    { value: 0, label: "0" },
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
  ],
  marksAmt: [
    { value: 0, label: "0" },
    { value: 25000, label: "25K" },
    { value: 50000, label: "50K" },
    { value: 75000, label: "75K" },
    { value: 100000, label: "100K" },
  ],
};

export default SliderMarks;
